<template>
  <form @submit.prevent="submitForm()" novalidate>
    <div>
      <mu-row gutter>
        <mu-col width="80" desktop="50" tablet="70">
          <mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-time-picker
                :label="$t('message.labelTime')"
                mode="portrait"
                fullWidth
                v-model="timeModel.time"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
              ></mu-time-picker>
            </mu-col>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-date-picker
                :label="$t('message.labelDate')"
                :okLabel="$t('message.okText')"
                :cancelLabel="$t('message.cancelText')"
                :dateTimeFormat="dateFormat"
                format="DD-MM-YYYY"
                v-model="timeModel.date"
                :maxDate="maxDate"
                fullWidth
              ></mu-date-picker>
            </mu-col>
          </mu-row>
          <mu-row gutter>
            <mu-col width="100" desktop="50" tablet="50">
              <mu-col width="100" tablet="50" desktop="50" v-if="preference === 'mgdl'">
                <mu-text-field
                  type="number"
                  v-validate
                  data-vv-validate-on="none"
                  :data-vv-rules="'required|min_value:0|max_value:63'"
                  data-vv-name="ketones_mgdl"
                  data-vv-value-path="inputValue"
                  :errorText="errors.first('ketones_mgdl')"
                  :label="$t('message.cardKetones')"
                  v-model.number="reading.mgdl"
                  :hintText="$t('message.placeholderText')"
                  :fullWidth="true"
                  helpText="mg/dL"
                />
              </mu-col>
              <mu-col width="100" tablet="50" desktop="50" v-if="preference === 'mmoll'">
                <mu-text-field
                  type="number"
                  v-validate
                  data-vv-validate-on="none"
                  :data-vv-rules="'required|min_value:0|max_value:3.5'"
                  data-vv-name="ketones_mmoll"
                  data-vv-value-path="inputValue"
                  :errorText="errors.first('ketones_mmoll')"
                  :label="$t('message.cardKetones')"
                  v-model.number="reading.mmoll"
                  :hintText="$t('message.placeholderText')"
                  :fullWidth="true"
                  helpText="mmol/L"
                />

              </mu-col>
            </mu-col>
          </mu-row>
        </mu-col>
      </mu-row>
    </div>
    <mu-flat-button
      style="margin-right: 8px;"
      :label="$t('message.discardText')"
      @click.native="closeEditMode(reading)"
    ></mu-flat-button>
    <button type="submit" style="display: none;"></button>
    <mu-raised-button
      @click.native="submitForm"
      :disabled="isUpdating"
      :label="isUpdating ? $t('message.updatingText') : $t('message.updateText')"
      type="button"
      secondary
    ></mu-raised-button>
  </form>
</template>
<script>



  import dateFormat from '../../../../helpers/DatePickerManager'
  import KetonesApi from '../../../../api/Tracking/Ketones'
  import ScrollerMixin from '../../../../mixins/ScrollerMixin'
  import TrackingEditMixin from '../../../../mixins/TrackingEditMixin'
  import ListsApi from '../../../../api/Lists'


  export default {
    mixins: [TrackingEditMixin, ScrollerMixin],
    name: 'ketones-edit',
    props: {
      preference: {
        type: String,
        default: 'mmoll'
      },
      item: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        isUpdating: false,
        reading: {
        }
      }
    },
    mounted() {
      let self = this;
    },
    methods: {
      submitForm() {
        let self = this;
        self.isUpdating = true;
        KetonesApi.updateKetonesTracking(self.reading)
          .then(function (response) {
            self.isUpdating = false;
            let offset = new Date();
            self.reading.date_created = moment(self.reading.date).add(offset.getTimezoneOffset().toString().replace('-', ''), 'minutes');
            self.$EventBus.$emit('ketonesReadingUpdated');
            self.$emit('updateReading', self.reading);
            self.$emit('closeEditPanel')
          })
          .catch(function () {
            self.isUpdating = false;
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// KetonesEdit.vue?57e1a6b6